import React, { ChangeEventHandler } from "react";

interface InputProps {
    placeholder?: string;
    label?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    type?: string;
    value?: string;
    disabled?: boolean;
    fill?: boolean;
    id?: string;
    small?: boolean;
    required?:boolean;
    autocomplete?: string;
    autofill?: string;
}

export function Input(props: InputProps) {

    return <>
        <div className={`input-container ${props.fill && "fill"} ${props.small && "small"}` }>
            <label>{props.label}{props.required && <span> *</span>}</label>
            <input className={`${props.disabled && "disabled"}`} {...props} />
        </div>
        <style jsx>
            {`
            .disabled{
                background:#F2F2F2;
                color:#868E96;
            }
            .input-container{
                display:flex;
                flex-direction: column;
                gap:4px;
            }
            .fill{
                width:100%;
                flex-grow:1;
            }
            span{
                color: var(--red);
            }
            input {
                box-sizing: border-box;
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                padding: 16px;
                gap: 10px;
                width: 100%;
                font-size:var(--font-size-3);
                height: 48px;
                background: #FFFFFF;
                border: 1px solid var( --border-color);
                border-radius: 4px;
                flex: none;
                order: 1;
                align-self: stretch;
                flex-grow: 0;
            }
            label{
                font-size:var( --font-size-2);
                color: ${props.disabled && "gray"};
            }
            .small input {
                padding: .5rem .75rem;
                border-radius: var(--border-radius);
                border: 1px solid var(--code-border);
                margin-left: auto;
                flex: 1 1 0%;
                font-size: var(--font-size-2);
            }
            .small .disabled {
                background: var(--code-background);
            }
            `}
        </style>
    </>;
}
